
import PIXI from '../GameEngine/pixi.js';
import Button from './ButtonSolid.js'
export default class DialogBox extends PIXI.Container {
    constructor(title, message, onConfirm, ...arg) {
        super(...arg);
        this.title = title || "Title";
        this.message = message || "message";
        this.onConfirm = onConfirm || function () { };
        this.onClose = function () { };



        this.interactive = true;
        this.on('pointerdown', this.close_onClick.bind(this));


        //background
        var popupBackground = new PIXI.Graphics();
        popupBackground.beginFill(0x000000);
        popupBackground.drawRect(-500, -500, 1000, 1000);
        popupBackground.alpha = 0.1;
        this.addChild(popupBackground);

        this.container = new PIXI.Container();
        this.addChild(this.container);




        var styleTitle = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 40 * 2,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });
        var styleLarge = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 32 * 2,
            fill: '#FFFFFF'
        });
        var styleNormal = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24 * 2,
            fill: '#FFFFFF',
            wordWrap: true,
            wordWrapWidth: 800,
            align: 'center'
        });
        let styleSmall = new PIXI.TextStyle({
            fontFamily: "Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue, Arial, sans-serif",
            fontSize: 12 * 2,
            fill: '#FFFFFF'
        });


        //background
        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x333333);
        graphics.lineStyle(0, 0xFFFFFF, 1);
        // graphics.drawRect(0, 0, 500, 500);
        graphics.drawRoundedRect(0, 0, 500, 300, 10);
        // graphics.alpha = 0.5;
        this.container.addChild(graphics);



        //textTitle
        this.textTitle = new PIXI.Text(this.title, styleTitle);
        this.textTitle.x = 250;
        this.textTitle.y = 10;
        this.textTitle.anchor.set(0.5, 0);
        this.textTitle.scale.set(0.5);
        this.container.addChild(this.textTitle);

        //textHeader1
        this.textHeader1 = new PIXI.Text(this.message, styleNormal);
        this.textHeader1.x = 250;
        this.textHeader1.y = 70;
        this.textHeader1.anchor.set(0.5, 0);
        this.textHeader1.scale.set(0.5);
        this.container.addChild(this.textHeader1);


        //Explain  button
        this.btnExplain = new Button("Cancel", 0xC03500);
        this.btnExplain.x = 20;
        this.btnExplain.y = 220;
        this.btnExplain.interactive = true;
        this.btnExplain.on('pointerdown', this.btnCancel_onClick.bind(this));
        this.container.addChild(this.btnExplain);

        //Next Round  button
        this.btnNext = new Button("OK", 0x479ACE);
        this.btnNext.x = 260;
        this.btnNext.y = 220;
        this.btnNext.interactive = true;
        this.btnNext.on('pointerdown', this.buttonConfirm_onClick.bind(this));
        this.container.addChild(this.btnNext);

        // //textTapToContinue
        // this.textTapToContinue = new PIXI.Text('Tap to continue', styleSmall);
        // this.textTapToContinue.x = 250;
        // this.textTapToContinue.y = 285;
        // this.textTapToContinue.anchor.set(0.5, 0);
        // this.textTapToContinue.scale.set(0.5);
        // this.container.addChild(this.textTapToContinue);

        //center content
        this.container.x = 0 - (this.container.width / 2);
        this.container.y = 0 - (this.container.height / 2);

    }



    buttonConfirm_onClick(event) {
        if (this.onConfirm) {
            this.onConfirm();
        }
        if (this.parent) {
            this.parent.isDirty = true;
            this.parent.removeChild(this);
        }
        event.stopPropagation();
    }
    btnCancel_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        if (this.parent) {
            this.parent.isDirty = true;
            this.parent.removeChild(this);
        }
        event.stopPropagation();
    }
    close_onClick(event) {
        if (this.onClose) {
            this.onClose();
        }
        if (this.parent) {
            this.parent.isDirty = true;
            this.parent.removeChild(this);
        }
        event.stopPropagation();
    }
}